import { Wrench, Car, Trees, Home, Shirt, Cpu, Volleyball, Baby, HardHat, Package, Gamepad2, BrickWall } from "lucide-react";

export const CATEGORIES = [
  { key: "tools", icon: Wrench, lt: "Įrankiai", ru: "Инструменты", en: "Tools" },
  { key: "auto_parts", icon: Car, lt: "Auto detalės", ru: "Автозапчасти", en: "Auto Parts" },
  { key: "garden", icon: Trees, lt: "Sodo technika", ru: "Садовая техника", en: "Garden" },
  { key: "household", icon: Home, lt: "Buitis", ru: "Быт", en: "Household" },
  { key: "clothing", icon: Shirt, lt: "Apranga", ru: "Одежда", en: "Clothing" },
  { key: "electronics", icon: Cpu, lt: "Elektronika", ru: "Электроника", en: "Electronics" },
  { key: "sports", icon: Volleyball, lt: "Sportas", ru: "Спорт", en: "Sports" },
  { key: "kids", icon: Baby, lt: "Vaikams", ru: "Детям", en: "Kids" },
  { key: "construction", icon: HardHat, lt: "Statyba", ru: "Стройка", en: "Construction" },
  { key: "construction_materials", icon: BrickWall, lt: "Statybinės medžiagos", ru: "Стройматериалы", en: "Building Materials" },
  { key: "video_games", icon: Gamepad2, lt: "Video žaidimai", ru: "Видеоигры", en: "Video Games" },
  { key: "other", icon: Package, lt: "Kita", ru: "Другое", en: "Other" },
];

export const TYPE_LABELS = {
  sell: { lt: "Parduodu", ru: "Продаю", en: "Selling" },
  free: { lt: "Atiduodu", ru: "Отдаю", en: "Free" },
  trade: { lt: "Mainau", ru: "Меняю", en: "Trade" },
  auction: { lt: "Aukcionas 24h", ru: "Аукцион 24ч", en: "Auction 24h" },
};
